import React from 'react';
import Markdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import { Link } from 'react-router-dom';
import AuthImage from './AuthImage';
import Style from './index.module.css';

interface Props {
  slug: string;
  markdown: string;
}

/** Lenke til et annet forretningsdokument, f.eks. `../kjede-forretning.md#regler` → `/docs/kjede#regler`. */
const INTERN_DOKUMENTLENKE = /(?:^|\/)([^/#]+)-forretning\.md(#.*)?$/;

const MarkdownDocument = ({ slug, markdown }: Props) => {
  const components: Components = {
    a: ({ href, children }) => {
      if (!href) return <>{children}</>;
      if (href.startsWith('#')) return <a href={href}>{children}</a>;
      if (/^https?:\/\//i.test(href))
        return (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        );
      const dokument = INTERN_DOKUMENTLENKE.exec(href);
      if (dokument) return <Link to={`/docs/${dokument[1]}${dokument[2] ?? ''}`}>{children}</Link>;
      // Lenker til kode og tekniske dokumenter (intent.md, .github/...) finnes ikke i portalen.
      return <span>{children}</span>;
    },
    img: ({ src, alt }) => {
      if (!src || /^https?:\/\//i.test(src)) return <em>[{alt}]</em>;
      return <AuthImage slug={slug} path={src.replace(/^\.?\/?images\//, '')} alt={alt} />;
    },
    table: ({ children }) => <table className="table table-sm table-bordered">{children}</table>,
  };

  return (
    <div className={Style.markdown}>
      <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]} components={components}>
        {markdown}
      </Markdown>
    </div>
  );
};

export default MarkdownDocument;
